import ApiClient from '@/services/apiClient';

export default class AlarmOutput {
    mode;
    output_number;
    external_alarm_id;

    constructor() {
        this.mode = 0;
        this.output_number = "";
        this.external_alarm_id = "";
    }

    static constructFromObject(data, obj) {
        obj = obj || new AlarmOutput();
        if (data) {
            if('output_number' in data) {
                obj.mode = 0;
                obj.output_number = data['output_number'] === ""? "" : ApiClient.convertToType(data['output_number'], 'Integer');
            }
            if('external_alarm_id' in data) {
                obj.mode = 1;
                obj.external_alarm_id = data['external_alarm_id'] === ""? "" : ApiClient.convertToType(data['external_alarm_id'], 'Integer');
            }
            if('mode' in data) {
                obj.mode = ApiClient.convertToType(data['mode'], 'Integer');
            }
        }
        return obj;
    }

    toJSON() {
        if(this.mode == 0) {
            return {
                output_number: this.output_number,
            }
        } else {
            return {
                external_alarm_id: this.external_alarm_id,
            }
        }
    }
}
